import { render, staticRenderFns } from "./VehicleInstallationsView.vue?vue&type=template&id=459c790a&"
import script from "./VehicleInstallationsView.vue?vue&type=script&lang=js&"
export * from "./VehicleInstallationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459c790a')) {
      api.createRecord('459c790a', component.options)
    } else {
      api.reload('459c790a', component.options)
    }
    module.hot.accept("./VehicleInstallationsView.vue?vue&type=template&id=459c790a&", function () {
      api.rerender('459c790a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Vehicles/Views/VehicleInstallationsView.vue"
export default component.exports